import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';

const MeatballMenuStyled = Styled.span`
	display: flex;
	justify-content:center;
	cursor:pointer;
	width: 60px;
	height:30px;
	border-radius: 4px;
	padding-left: 15px;
`;

const StyledSVG = Styled.svg`
	align-self:center;
`;

export const MeatballMenuIcon = ({onClick, userpilot, cy}) => {
	return (
		<MeatballMenuStyled style={{overflow: 'visible'}} onClick={onClick} data-userpilot={userpilot} data-cy={cy}>
			<StyledSVG xmlns="http://www.w3.org/2000/svg" height="18px" width="40px">
				<path d="M-.107143-.07242846h24V23.927572h-24z" fill="none" />
				<g transform="translate(-10 -3.0019999)" fill="#757575">
					<circle r="2" cy="12" cx="12" />
					<circle r="2" cy="12" cx="18" />
					<circle r="2" cy="12" cx="24" />
				</g>
			</StyledSVG>
		</MeatballMenuStyled>
	);
};

MeatballMenuIcon.propTypes = {
	onClick: PropTypes.func,
	userpilot: PropTypes.string,
	cy: PropTypes.string,
};
